import { render, staticRenderFns } from "./TargetPersonFormComponent.vue?vue&type=template&id=fe79520c&scoped=true&"
import script from "./TargetPersonFormComponent.vue?vue&type=script&lang=ts&"
export * from "./TargetPersonFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TargetPersonFormComponent.vue?vue&type=style&index=0&id=fe79520c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe79520c",
  null
  
)

export default component.exports